<template>
	<a-drawer title="附件信息" width="60%" :closable="false" :visible="visible" :destroyOnClose="true" @close="onClose">
		<a-table :bordered="true" :columns="innerColumns" :data-source="dataSource" :pagination="false">
			<template slot="action" slot-scope="text, record">
				 <a size="small" @click="downloadFile(record)">下载</a>
				 <a-divider v-if="fileTypeArr.includes(record.fileSurffix.toLowerCase())" type="vertical" />
				 <a size="small" v-if="fileTypeArr.includes(record.fileSurffix.toLowerCase())" @click="getStream(record)">预览图片</a>
			</template>
		</a-table>
		<a-modal v-model="visibleVoucher" title="图片预览" :footer="null" width="50%">
		      <img :src="iframeUrl" width="100%"/>
		</a-modal>
	</a-drawer>

</template>

<script>
	import Content from './weiboContent';
	import UserTaskRecord from './userTaskRecord';
	import Approval from './approval';

	const formItemLayout = {
		labelCol: {
			span: 2
		},
		wrapperCol: {
			span: 22
		}
	}

	const innerColumns = [
	  { title: '文件名', dataIndex: 'fileFullName',align: 'left'},
	  { title: '上传时间', dataIndex: 'createTime',align: 'left'},
	  {title: '操作',dataIndex: 'action',scopedSlots: { customRender: 'action' },align: 'center',width: 200}
	];

	export default {
		props: {
			visible: {
				default: false
			},
		},
		components:{
			Content,
			UserTaskRecord,
			Approval
		},
		data() {
			return {
				platformDataList: [
					{name: '微博',value: 'weibo',color: '#FED754',url: '../../../../static/img/weibo.png'},
					{name: '抖音',value: 'douyin',color: '',url: '../../../../static/img/douying.png'},
					{name: 'B站',value: 'bilibili',color: '',url: '../../../../static/img/blibli.png'},
					{name: '小红书',value: 'redbook',color: '', url: '../../../../static/img/redbook.png'},
					{name: '快手',value: 'kuaishou',color: '', url: '../../../../static/img/kuaishou.png'},
					{name: '视频号',value: 'channels',color: '', url: '../../../../static/img/channels.png'},
				],
				platformTypeArr: [],
				formItemLayout,
				form: this.$form.createForm(this),
				id: null,
				loading: false,
				moveIndex: null,
				fileTypeArr: ['png','jpeg','jpe','jpg'],
				accountList: [],
				award: {},
				notApprovalStateArr: ['team_leader_resubmit','audit_resubmit'],
				innerColumns,
				dataSource: [],
				visibleVoucher: false,
				iframeUrl: null,
			}
		},
		methods: {
			init({...item}){
				this.$get(`file/fileList/award_file/${item.parent_id}`).then(res => {
					this.dataSource = res.data
				});
			},
			success(){
				this.$emit('success');
			},
			onClose() {
				this.form.resetFields();
				this.$emit('close')
			},
			// 流赋值
			lookImg(v) {
				let that = this;
				this.$get('file/fileList/remaining_file/' + v.id).then((r) => {
					if (r.data.length > 0) {
						that.fileList = r.data;
						for (var i = 0; i < this.fileList.length; i++) {
							that.getStream(this.fileList[i]);
						}
						that.visibleVoucher = true;
					} else {
						this.$message.warning('暂无凭证');
					}
				})
			},
			downloadFile(row){
				this.$download("file/downloadFile/"+row.id,{},row.fileFullName).then(res => {
				});
			},
			// 获取图片流
			getStream(file) {
				this.$stream(`file/getFileInputStream/${file.id}`).then(res => {
					this.iframeUrl = window.URL.createObjectURL(res.data);
					this.visibleVoucher = true;
				})
			},
		},
	}
</script>
<style lang="less" scoped>
	.heder{
	  background-color: #fff;
	  display: flex;
	  flex-wrap: wrap;
	  align-items: center;
	  .selectPlatform{
	    margin: 0 10px 0 6%;
	    color: #9094a3;
	  }
	  .platform{
	    width: 15%;
	    height: 50px;
	    font-size: 16px;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    border: 1px solid #e7e7e7;
	    border-radius: 6px;
		margin-bottom: 10px;
	    margin-right: 10px;
	    cursor: pointer;
	    img{
	      width: 30px;
	      margin-right: 10px;
	    }
	  }
	  .active{
	    border: 1px solid #74D56F !important;
	    background-color: #40AE36;
	    color: #fff;
	  }
	  .forbid{
	    background-color: #F5F5F5;
	    cursor: not-allowed !important;
	  }
	}
	.formItemLayoutBackground{
		/deep/.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content{
			background-color: #fff !important;
			border: 1px solid #E8E8E8 !important;
		}
		/deep/ table {
			border-left: 1px solid black !important;
			border-bottom: 1px solid black !important;
		}
		/deep/ table > .ant-table-thead > tr > th {
			border-right: 1px solid black !important;
			border-top: 1px solid black !important;
		}
		/deep/ table > .ant-table-tbody > tr > td {
			border-right: 1px solid black !important;
			border-top: 1px solid black !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/OA/qualityContent/fileList.vue